// extracted by mini-css-extract-plugin
module.exports = {"applePayButton":"TogglePaymentButton_applePayButton__4M2DM","logo":"TogglePaymentButton_logo__FUpNJ"};